export default __webpack_public_path__ + "f04a6f5afd4dadc8ed9009ebf7b03f8d.png";